import {
  type RouteObject,
} from "react-router";
import { WebformDetailApp } from "webform/Detail/App";
import WebformList from "webform/List/App";

declare let viewModel: any;

export const webformRoute: RouteObject = {
  path: "webform",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: WebformList,
  }, {
    path: ":webformId",
    loader: () => viewModel,
    Component: WebformDetailApp,
  }]
};